export class ListOAuthAppsResponse {
    'oauthApps';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "oauthApps",
            "baseName": "oauthApps",
            "type": "Array<OAuthApp>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListOAuthAppsResponse.attributeTypeMap;
    }
    constructor() {
    }
}
